import { ConnectionMessageType, type ConnectionMessage } from '@playcastdotio/Messaging';
import { beaconResolveState } from '../../../stores/beaconStores';
import { setIsReady } from '..';

export const handleBeaconConnectionMessage = (message: ConnectionMessage): void => {
  switch (message.type) {
    case ConnectionMessageType.CONN_BEACON_FAST_START_SUCCESS: {
      setIsReady(true);
      beaconResolveState.updateState({
        status: 'resolved',
        hostPeerId: message.hostPeerId,
        peerId: message.peerId,
        peerToken: message.peerToken,
        iceServers: message.iceServers,
        streamTitle: message.streamTitle,
        errorCode: undefined,
        errorMessage: undefined,
        errorStage: undefined,
      });
      break;
    }
    case ConnectionMessageType.CONN_BEACON_FAST_START_ERROR: {
      beaconResolveState.updateState({
        status: 'error',
        hostPeerId: undefined,
        peerId: undefined,
        peerToken: undefined,
        iceServers: undefined,
        errorCode: message.error.code,
        errorMessage: message.error.message,
        errorStage: message.stage,
      });
      break;
    }
    default:
      break;
  }
};
